import { render, staticRenderFns } from "./JournalLpo__table.vue?vue&type=template&id=e70db902&scoped=true&"
import script from "./JournalLpo__table.vue?vue&type=script&lang=js&"
export * from "./JournalLpo__table.vue?vue&type=script&lang=js&"
import style0 from "./JournalLpo__table.vue?vue&type=style&index=0&id=e70db902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70db902",
  null
  
)

export default component.exports